/**
 * The list of string that represents part of the error that should be filtered and don't send to datadog
 */
export const errorsToSuppress = [
  'Guest id:' /* a id for guest FF support */,
  'font-size: 3rem; color: tomato;' /* a id for guest FF support */,
  'Refresh token expired',
  'Network Error',
  'react-use-intercom', // https://github.com/devrnt/react-use-intercom/issues/726
];
